'use strict'

import React from 'react';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ])
  .loadVariants([
    require('./labels/english_endStage.js'),
    require('./labels/norwegian_endStage.js'),
    require('./labels/english_endProject.js'),
    require('./labels/norwegian_endProject.js')
  ])
  ;

class StatusItem extends React.Component {
  selectStatus(event) {
    this.props.selectStatus(this.props.color);
    event.preventDefault();
  }

  render() {
    return (
      <div style={{display: "table-row"}}>
        <a onClick={this.selectStatus.bind(this)} href="#" style={{display: "table-cell"}}>
          <img src={this.props.imageUrl}/>
        </a>
       <div style={Object.assign({},{display:"table-cell"},this.props.style)}>{this.props.description}</div>
      </div>
    );
  }
}

export default class StatusSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state={color:this.props.value!==undefined ? this.props.value : "green"};
  }

  getStatusImage(status) {
    switch (status) {
      case "green": return "greenlight.png";
      case "yellow": return "yellowlight.png";
      case "red": return "redlight.png";
    }
  }

  selectStatus(color) {
    this.setState({color:color});
    this.changeStatus(undefined);
    if (this.props.onChange!==undefined) {
      this.props.onChange({
        target:{
          name: this.props.name+"_status",
          value:color
        }
      });
    }
  }

  componentDidMount() {
    this.setState({hideSelect: true})
  }

  changeStatus(event) {
    if (event!==undefined) {
      event.preventDefault();
    }
    this.setState({showOptions:!this.state.showOptions});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div>
        <div style={this.props.style===undefined ? {float: "right"} : undefined}>
        {this.state.hideSelect
          ? (
              <div style={{position: "relative", marginRight: 20}}>
                {this.state.showOptions
                  ? (
                    <div>
                      <a href="#" onClick={this.changeStatus.bind(this)}><img src={"/images/"+this.getStatusImage(this.state.color)}/></a>
                      <input type="hidden" name={this.props.name+"_status"} value={this.state.color}/>
                      <div style={{display: "table", zIndex: 1, position: "absolute", textAlign:"left", top: this.props.style!==undefined ? this.props.style.top : -30, right: this.props.style!==undefined ? this.props.style.right : -20, left: this.props.style!==undefined ? this.props.style.left : undefined, width: 300, border: "solid black 1px", borderRadius: 10, backgroundColor:"lightGrey", padding: this.props.style!==undefined ? this.props.style.padding : undefined}}>
                        {["green", "yellow", "red"].map(function(color) {
                          return (
                            <StatusItem key={color}
                                        color={color}
                                        imageUrl={"/images/"+this.getStatusImage(color)}
                                        description={labels.status[color]}
                                        selectStatus={this.selectStatus.bind(this)}
                                        style={this.props.style!==undefined ? this.props.style.item : undefined}
                            />
                          );
                          }.bind(this))}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <a href="#" onClick={this.changeStatus.bind(this)}><img src={"/images/"+this.getStatusImage(this.state.color)}/></a>
                      <input type="hidden" name={this.props.name+"_status"} value={this.state.color}/>
                    </div>
                  )
                }
              </div>
          ) : (
          <div>
            <select name={this.props.name+"_status"}>
              <option value="green">Green</option>
              <option value="yellow">Yellow</option>
              <option value="red">Red</option>
            </select>
            <div style={{display:"inline-block", opacity: "0.4", border:"solid grey 1px", borderRadius: 10, padding: 2}}>
              <img src="/images/green_14x18.gif"/>
              <img src="/images/yellow_18x16.gif"/>
              <img src="/images/red_18x18.gif"/>
            </div>
          </div>
        )
      }
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/StatusSelector.jsx